import React from 'react';
import { Link } from 'react-router-dom';

export default function HighlightedWorks({ works }) {
    return (
        <div className="mx-auto max-w-4xl px-6 lg:px-8 pt-28 sm:pt-36">
            {works.map((work) => (
                <div key={work.id} className="mb-16 mt-8 lg:mt-0">
                    <div className="mb-6">
                        <p className="text-xs font-outfit font-semibold tracking-[0.2em] uppercase text-accent mb-2">
                            {work.workType}
                        </p>
                        <h2 className="font-syne text-2xl font-bold text-text-primary">
                            {work.name}
                        </h2>
                    </div>

                    <div className="flex flex-col items-center">
                        {work.images && work.images.length > 0 && (
                            <img
                                src={work.images[0]}
                                alt={`${work.name} main`}
                                className="rounded-xl border border-border-subtle"
                            />
                        )}
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-3 w-full">
                            {work.images &&
                                work.images.slice(1, 5).map((imgSrc, idx) => (
                                    <img
                                        key={idx}
                                        src={imgSrc}
                                        alt={`${work.name} thumbnail ${idx}`}
                                        className="mx-auto rounded-lg border border-border-subtle"
                                    />
                                ))}
                        </div>
                    </div>

                    <div className="mt-6">
                        <h3 className="font-syne text-xl font-bold text-text-primary mb-3">
                            {work.subheading}
                        </h3>
                    </div>

                    <div className="text-start">
                        <p className="font-outfit text-sm text-text-secondary whitespace-pre-line leading-relaxed">
                            {work.description}
                        </p>
                        <div className="mt-8">
                            <Link
                                to={`/works/${work.pageName}`}
                                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent/10 text-accent border border-accent/20 font-outfit font-semibold text-sm hover:bg-accent/20 transition-all duration-300"
                            >
                                Explore Work
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
